// Tabs/TabPanelContent.references.tsx
import React from 'react';
import ReferenceTableCard from '../components/tabs/references/ReferenceTable';
import ReferenceCard from '../components/tabs/references/Reference';
import DynamicTabContentTable from './DynamicTabContentTable';

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentReferences: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <ReferenceTableCard header={'References'} eventGroupToTrigger={'references'} />
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="references" />
        </div>
        <div className="col-3 col-sm-3">
            <ReferenceCard header={'Reference'} eventGroupToTrigger={'references'} />
        </div>
    </div>
);

export default TabPanelContentReferences;
